import { AbstractControl, ValidatorFn } from '@angular/forms';

export function ForbiddenEmailValidator(loggedInUserEmail: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!loggedInUserEmail) {
      return null;
    }

    const forbidden = loggedInUserEmail === control.value;

    return forbidden ? { forbiddenEmail: { value: control.value } } : null;
  };
}
